import { Person } from '@/types/person';

const isEligibleForPostScheduledIntake = (person: Person): boolean => {
  // Specific classification for PSI eligibility doesn't exist, so we use the intake scheduled classification as a proxy.
  return person.classifications.includes('has_scheduled_intake');
};

export default isEligibleForPostScheduledIntake;
